import axios from './axios';

const API_URL = '/C4-Nicaragua/Empresa'; // ajusta si usas otro endpoint"el nombre del archivo de route de backend 

export const getEmpresa = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los datos :', error);
    return [];
  }
};
export const updateEmpresa = async (id, empresa) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, empresa);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar datos', error);
    throw error;
  }
};